import {
  Box, Grid, Typography, makeStyles,
} from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';

function CallToAction() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles(() => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  useEffect(() => {
    // we need to remove and reload the script to force Salsa to update the div.
    const existingScript = document.getElementById('covidSalsa');
    if (existingScript) {
      document.body.removeChild(existingScript);
    }
    const script = document.createElement('script');
    script.src = 'https://default.salsalabs.org/api/widget/template/e2673345-9115-4109-b8cc-7878db48b901/?tId=c6067d54-322d-4487-a5bb-3b00910bdd60';
    script.id = 'covidSalsa';
    document.body.appendChild(script);
  });

  return (
    <Box displayPrint="none">
      <SubquestionBox color={lightColor}>
        <Grid
          spacing={2}
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
              Call to action
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={10} sm={6}>
                <MessageBox>
                  <Box className="ccdc-salsa">
                    <Box id="c6067d54-322d-4487-a5bb-3b00910bdd60" className="ccdc-salsa" />
                  </Box>
                </MessageBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SubquestionBox>
    </Box>
  );
}

export default CallToAction;
